import APIService from '../api.service';

export const List = (params) => {
  return APIService.get(`/v01/productions`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
      sku: params.sku
    },
  });
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/productions`, body, config);
};

export const Put = (payload, config = {}) => {
  const { id } = payload;
  return APIService.put(`/v01/productions/${id}`, {...payload}, config);
};

export const Show = (id, config = {}) => {
  return APIService.get(`/v01/productions/${id}`, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/v01/productions/${id}`, config);
};

export const All = () => {
  return APIService.get(`v01/productions/get-all`);
}

export const CreateIngredient = (body, config = {}) => {
  return APIService.post(`/v01/ingredients`, body, config);
};

export const UpdateIngredient = (payload, config = {}) => {
  const { id } = payload;
  return APIService.put(`/v01/ingredients/${id}`, {...payload}, config);
};

export const DeleteIngredient = (id, config = {}) => {
  return APIService.delete(`/v01/ingredients/${id}`, config);
};

export const CreateWaste = (body, config = {}) => {
  return APIService.post(`/v01/wastes`, body, config);
};

export const UpdateWaste = (payload, config = {}) => {
  const { id } = payload;
  return APIService.put(`/v01/wastes/${id}`, {...payload}, config);
};

export const DeleteWaste = (id, config = {}) => {
  return APIService.delete(`/v01/wastes/${id}`, config);
};

export const CreateCutUnit = (body, config = {}) => {
  return APIService.post(`/v01/cut-units`, body, config);
};

export const UpdateCutUnit = (payload, config = {}) => {
  const { id } = payload;
  return APIService.put(`/v01/cut-units/${id}`, {...payload}, config);
};

export const DeleteCutUnit = (id, config = {}) => {
  return APIService.delete(`/v01/cut-units/${id}`, config);
};

const ProductionService = {
  List,
  Create,
  Put,
  Show,
  Delt,
  All,
  CreateIngredient,
  UpdateIngredient,
  DeleteIngredient,
  CreateWaste,
  UpdateWaste,
  DeleteWaste,
  CreateCutUnit,
  UpdateCutUnit,
  DeleteCutUnit
};
export default ProductionService;
